import { render, staticRenderFns } from "./MyGroups.vue?vue&type=template&id=59b6359c&"
import script from "./MyGroups.vue?vue&type=script&lang=js&"
export * from "./MyGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports